import { BACKGROUND_INVERSE, DARK, HPP_DARK, HPP_DARK_MOBILE, HPP_LIGHT, LIGHT } from '../colors'

import PageNames from 'pages/page-names'
import debounce from 'lodash.debounce'

export const BREAKPOINT = 769

function getSize() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  }
}

export const setGlobalBackground = isDarkMode => {
  const root: HTMLBaseElement = document.querySelector('#root')
  let size = getSize()

  function isMobile() {
    return size.width < BREAKPOINT
  }

  const onResizeHandler = debounce(function onResizeHandler() {
    size = getSize()
  }, 100)

  window.addEventListener('resize', onResizeHandler, false)

  const page = window.HPP_SETTINGS.page
  const includedPages = [
    PageNames.PAYMENT_BOOTSTRAP,
    PageNames.PAYMENT_BOOTSTRAP_LIGHT,
    PageNames.PAYMENT_BOOTSTRAP_EXPRESS,
    PageNames.PAYMENT_SUCCESS
  ]

  if (page === PageNames.DISTRIBUTION_PAYMENT) return

  if (root && root.style) {
    if (includedPages.includes(page)) {
      if (isMobile()) {
        root.style.backgroundColor = isDarkMode ? HPP_DARK_MOBILE : 'white'
      } else {
        root.style.backgroundColor = isDarkMode ? HPP_DARK : HPP_LIGHT
      }
    } else {
      root.style.backgroundColor = BACKGROUND_INVERSE[isDarkMode ? DARK : LIGHT]
    }
  }
}
